import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CheckCircle2, Book, Brain, Map, MessageCircleHeart, Gift } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <Book className="w-6 h-6" data-id="element-239" />,
    title: 'eBook "El Kit de Primeros Auxilios Emocionales"',
    desc: 'La hoja de ruta para entender tu reactividad y detenerla en seco.'
  }, {
    icon: <Brain className="w-6 h-6" data-id="element-240" />,
    title: 'Técnica 5-4-3-2-1 Bilingüe',
    desc: 'El ejercicio mental exacto para apagar el modo de pánico.'
  }, {
    icon: <Map className="w-6 h-6" data-id="element-241" />,
    title: 'El Mapa de Detonantes',
    desc: 'Herramienta para identificar tus "gatillos" antes de que la chispa toque la gasolina.'
  }, {
    icon: <MessageCircleHeart className="w-6 h-6" data-id="element-242" />,
    title: 'Biblioteca de Guiones de Reparación',
    desc: 'Qué decir exactamente después de una explosión para sanar el vínculo con tus hijos.'
  }];
  return <AnimatedSection className="bg-cream" data-id="element-243">
      <div className="max-w-6xl mx-auto" data-id="element-244">
        <div className="text-center mb-16" data-id="element-245">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-246">
            Todo lo que incluye tu Kit de Emergencia
          </h2>
          <p className="text-lg text-charcoal-light" data-id="element-247">
            Herramientas tácticas, directas al grano y listas para usar hoy
            mismo.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-248">
          <div className="lg:col-span-5 relative" data-id="element-249">
            <div className="absolute inset-0 bg-mint/20 blur-3xl rounded-full transform scale-90" data-id="element-250" />
            <img src="https://cdn.magicpatterns.com/uploads/gAQTXyZ31dUDpJmM5dMYfj/El_Kit_de_Primeros_Auxilios_Emocionales.png" alt="Contenido del Kit" className="relative z-10 w-full h-auto drop-shadow-xl rounded-2xl" data-id="element-251" />
          </div>

          <div className="lg:col-span-7 space-y-6" data-id="element-252">
            {items.map((item, index) => <div key={index} className="flex gap-4 bg-white p-5 rounded-2xl shadow-sm border border-mint-light/50" data-id="element-253">
                <div className="bg-mint-light text-mint-dark p-3 rounded-xl flex-shrink-0 h-fit" data-id="element-254">
                  {item.icon}
                </div>
                <div data-id="element-255">
                  <h3 className="font-bold text-lg text-charcoal mb-1" data-id="element-256">
                    {item.title}
                  </h3>
                  <p className="text-charcoal-light" data-id="element-257">{item.desc}</p>
                </div>
              </div>)}

            {/* Bonus Item */}
            <div className="flex gap-4 bg-gradient-to-r from-gold/10 to-gold/5 p-6 rounded-2xl border border-gold/30 relative overflow-hidden mt-8" data-id="element-258">
              <div className="absolute top-0 right-0 bg-gold text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-259">
                Bono Exclusivo
              </div>
              <div className="bg-gold text-white p-3 rounded-xl flex-shrink-0 h-fit" data-id="element-260">
                <Gift className="w-6 h-6" data-id="element-261" />
              </div>
              <div data-id="element-262">
                <h3 className="font-bold text-lg text-charcoal mb-1" data-id="element-263">
                  Tarjetas de Emergencia para la Nevera
                </h3>
                <p className="text-charcoal-light" data-id="element-264">
                  Frases de auxilio instantáneo listas para imprimir y pegar
                  donde más las necesitas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}